export default {
    props: {
        enableFieldBatchEdit: {
            type: Boolean,
            default: false
        },
        /*[{
         *  key: '',
         *  customApi: '',//未支持
         *}]
         */
        acceptBatchEditFields: {
            type: [Array, String],
            default: ''
        },
    },
    data() {
        return {
            batchEditSaveLoading: false,
            currentBatchEditingField: {},
            currentBatchEditingData: null,
        }
    },
    computed: {
        activeEditFields() {
            let temp = [];
            if (this.acceptBatchEditFields) {
                if (typeof this.acceptBatchEditFields === 'string') {
                    let split = this.acceptBatchEditFields.split(",");
                    for (let s of split) {
                        temp.push({
                            key: s.trim()
                        })
                    }
                } else if (this.acceptBatchEditFields instanceof Array) {
                    temp = this.acceptBatchEditFields;
                }
            }
            let map = new Map();
            temp.forEach(o => map.set(o.key, o));
            for (let field of this.$_emCustomVuexMixin_entityConfigs) {
                if (map.has(field.key)) {
                    map.get(field.key).config = field;
                }
            }
            temp = [];
            for (let t of map.values()) {
                if (t.config) {
                    t.label = this.$t(t.config.label);
                    temp.push(t);
                }
            }
            return temp;
        },
    },
    methods: {
        openBatchEditModal(f) {
            let rows = this.checkedItemsRows;
            if (rows && rows.length === 1) {
                this.currentBatchEditingData = this.checkedItemsRows[0][f.key];
            }
            this.currentBatchEditingField = f;
            this.$refs.batchEdit.showModal();
        },
        clearBatchEdit() {
            this.currentBatchEditingField = {};
            this.currentBatchEditingData = null;
        },
        changeBatchEditingData(val) {
            this.currentBatchEditingData = val;
        },
        saveBatchEdit() {
            let f = this.currentBatchEditingField;
            let ids = this.checkedItems;
            if (f && ids.length > 0) {
                this.batchEditSaveLoading = true;
                let tempList = [];
                ids.forEach(id => {
                    let temp = {id: id};
                    temp[f.key] = this.currentBatchEditingData;
                    tempList.push(temp);
                })
                let url = `${this.$store.state[this.entity].baseModuleUrl}/${this.entity}/saveAllSelective`;
                this.$store.dispatch('api/put', {
                    url: url,
                    entity: tempList,
                }).then(() => {
                    this.$message.success("修改成功");
                    this.$store.commit(`${this.entity}/setNeedToRefresh`, true);
                }).finally(() => {
                    this.batchEditSaveLoading = false;
                    this.$refs.batchEdit.hide();
                });
            }
        },
    }
}
